var Backbone = require('backbone');


var ReviewRequestModel = Backbone.Model.extend({
    defaults: {
        id: undefined,
        name: 'Review Request',
        object: {
            reviewRequestElements: [],
            requesterOrganizationId: undefined
        },
        createdBy: undefined
    },

    urlRoot: '/api/review',

    validate: function(attrs) {
        var errors = [];
        var hasError = false;
        if (!attrs.object || !attrs.object.reviewRequestElements || attrs.object.reviewRequestElements.length == 0) {
            errors.push('Review Request data is empty');
            hasError = true;
        }
        else {
            attrs.object.reviewRequestElements.forEach(function(item, indx) {
                var docIndex = indx + 1;
                if (item.documentId == undefined || item.documentId == '') {
                    errors.push('Document name was not selected for ' + docIndex+ '- Document');
                    hasError = true;
                }
                if (!item.reviewers || item.reviewers.length == 0) {
                    errors.push('Reviewers were not selected for ' + docIndex + '- Document');
                    hasError = true;
                }
                item.reviewers.forEach(function(revItem, indx2) {
                    var reviewersIndex = indx2 + 1;
                    if ((!revItem.organizationId || revItem.organizationId == '') && (!revItem.personId || revItem.personId == '')) {
                        errors.push('Organization or Person were not selected for ' + reviewersIndex + '- group of Reviewers of ' + docIndex + ' Document');
                        hasError = true;
                    }
                });
            });
        }

        if (hasError) {
            return errors;
        }
    },

    sync: function (method, model, options) {
        (model.get('object').reviewRequestElements || []).forEach(function(element){
            delete element['documentName'];
        });
        //delete model.get('createdBy')['relations'];
        options.attrs = model.attributes;
        return Backbone.sync.call(this, method, model, options);
    }

});


module.exports = ReviewRequestModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/review-request-model.js
// module id = 403
// module chunks = 0